import { Link, useLocation } from 'react-router-dom'

interface NavItem {
  name: string
  href: string
  icon: string
}

const navItems: NavItem[] = [
  { name: 'Overview', href: '/overview', icon: '📊' },
  { name: 'Expenses', href: '/expenses', icon: '💸' },
  { name: 'Income', href: '/income', icon: '💰' },
  { name: 'Recurring', href: '/recurring', icon: '🔄' },
  { name: 'Goals', href: '/goals', icon: '🎯' },
  { name: 'Net Worth', href: '/net-worth', icon: '🏦' },
  { name: 'Projections', href: '/projections', icon: '📈' }
]

export function Navigation() {
  const location = useLocation()
  const pathname = location.pathname

  return (
    <nav className="bg-white shadow-sm border-b border-stone/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/overview" className="flex items-center gap-2">
              <span className="text-2xl">🌿</span>
              <span className="font-bold text-xl text-forest-dark">
                Family Budget
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => {
              const isActive =
                pathname === item.href || pathname.startsWith(`${item.href}/`)
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-forest/10 text-forest-dark'
                      : 'text-charcoal/70 hover:text-charcoal hover:bg-cream'
                  }`}
                >
                  <span className="mr-1.5">{item.icon}</span>
                  {item.name}
                </Link>
              )
            })}
          </div>

          {/* User Menu */}
          <div className="flex items-center gap-4">
            <Link
              to="/settings"
              className={`text-sm transition-colors ${
                pathname === '/settings'
                  ? 'text-forest-dark'
                  : 'text-charcoal/70 hover:text-charcoal'
              }`}
            >
              ⚙️ Settings
            </Link>
            <LogoutButton />
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden pb-3 pt-1">
          <div className="flex space-x-1 overflow-x-auto">
            {navItems.map((item) => {
              const isActive =
                pathname === item.href || pathname.startsWith(`${item.href}/`)
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`px-3 py-2 rounded-lg text-xs font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? 'bg-forest/10 text-forest-dark'
                      : 'text-charcoal/70 hover:text-charcoal hover:bg-cream'
                  }`}
                >
                  <span className="mr-1">{item.icon}</span>
                  {item.name}
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </nav>
  )
}

function LogoutButton() {
  async function handleLogout() {
    await fetch('/api/auth/logout', { method: 'POST' })
    window.location.href = '/login'
  }

  return (
    <button
      onClick={handleLogout}
      className="text-sm text-charcoal/70 hover:text-danger transition-colors"
    >
      Sign Out
    </button>
  )
}
